// Global Table
import { avgEngagementRateHistoryConfig } from '@/lib/analyticsGroup/charts/avgEngagementRateHistory';
import { bestTimeToPostConfig } from '@/lib/analyticsGroup/charts/bestTimeToPost';
// Charts
import { followersGrowthConfig } from '@/lib/analyticsGroup/charts/followersGrowth';
import { followersOnlineConfig } from '@/lib/analyticsGroup/charts/followersOnline';
import { impressionsHistoryConfig } from '@/lib/analyticsGroup/charts/impressionsHistory';
import { postsDistributionConfig } from '@/lib/analyticsGroup/charts/postsDistribution';
import { groupGlobalTableConfig } from '@/lib/analyticsGroup/tables/groupGlobalTableConfig';
// Widgets
import { mostRecentPostsConfig } from '@/lib/analyticsGroup/widget/mostRecentPostsConfig';

export const OverviewGroupBaseConfig = [
    groupGlobalTableConfig,
    mostRecentPostsConfig,
    followersGrowthConfig,
    avgEngagementRateHistoryConfig,
    impressionsHistoryConfig,
    postsDistributionConfig,
    bestTimeToPostConfig,
    followersOnlineConfig
] as const;

export const requestGroupBaseParams = [
    'followers_growth',
    'average_engagement_rate_history',
    'impressions_history',
    'posts_distribution',
    'best_time_to_post',
    'followers_online'
];
